import { useEffect, useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { BrowserRouter as Router } from "react-router-dom";
import navIcon2 from "../assets/img/icons8-github2.svg";
import logo from "../assets/img/Logo Portfolio Websitepng.png";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

export const NavBar = () => {
  const [activeLink, setActiveLink] = useState("home");
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
    // Menue nach der Auswahl auf Mobilgeraeten wieder schliessen
    setExpanded(false);
  };

  const links = [
    { key: "home", href: "#home", label: "Home" },
    { key: "skills", href: "#skills", label: "Skills" },
    { key: "projects", href: "#projects", label: "Projekte" },
    { key: "timeline", href: "#timeline", label: "Karriere" },
    { key: "about", href: "#about", label: "Über mich" },
  ];

  return (
    <Router>
      <Navbar
        expand="lg"
        expanded={expanded}
        onToggle={setExpanded}
        className={scrolled ? "scrolled" : ""}
      >
        <Container>
          <Navbar.Brand href="/">
            <div className="navbar-brand-inner">
              <img src={logo} alt="Logo" className="navbar-brand-logo" />
              <p className="navbar-brand-name">Luca Liam Schäfer</p>
            </div>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" aria-label="Menü">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              {links.map((link) => (
                <Nav.Link
                  key={link.key}
                  href={link.href}
                  className={
                    activeLink === link.key
                      ? "active navbar-link"
                      : "navbar-link"
                  }
                  onClick={() => onUpdateActiveLink(link.key)}
                >
                  {link.label}
                </Nav.Link>
              ))}
            </Nav>
            <span className="navbar-text">
              <div className="social-icon">
                <a
                  href="https://www.linkedin.com/in/luca-liam-spie%C3%9Fl-sch%C3%A4fer-3b0751224/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="LinkedIn"
                >
                  <img src={navIcon1} alt="" />
                </a>
                <a
                  href="https://github.com/LiamSchaefer"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="GitHub"
                >
                  <img src={navIcon2} alt="" style={{ width: "70%" }} />
                </a>
                <a
                  href="https://www.instagram.com/luca_liam.photography/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Instagram"
                >
                  <img src={navIcon3} alt="" />
                </a>
              </div>
            </span>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Router>
  );
};
